import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { FaFacebook, FaLinkedin, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { company, services } from '../data/site';
import { solutions } from '../data/solutions';

const socials = [
  { label: 'Fedigma on LinkedIn', href: company.socials.linkedin, icon: FaLinkedin },
  { label: 'Fedigma on Instagram', href: company.socials.instagram, icon: FaInstagram },
  { label: 'Fedigma on Facebook', href: company.socials.facebook, icon: FaFacebook },
  { label: 'Chat with Fedigma on WhatsApp', href: company.whatsapp, icon: FaWhatsapp }
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <Link to="/" className="logo">
              <img src="/logo-64.png" className="logo-mark" alt="" width="32" height="32" />
              {company.name}
            </Link>
            <p>
              {company.tagline}. One partner for every digital need of schools,
              colleges, kindergartens, libraries and institutes.
            </p>
            <div className="social-links">
              {socials.map(({ label, href, icon: SocialIcon }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                  <SocialIcon />
                </a>
              ))}
            </div>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <ul className="footer-links">
              {services.map((service) => (
                <li key={service.id}><Link to={service.link}>{service.title}</Link></li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Solutions</h3>
            <ul className="footer-links">
              {solutions.map((solution) => (
                <li key={solution.id}><Link to={`/solutions/${solution.id}`}>{solution.name}</Link></li>
              ))}
            </ul>

            <h3 className="footer-subhead">Company</h3>
            <ul className="footer-links">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/work">Our work</Link></li>
              <li><Link to="/free-audit">Free digital audit</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Get in touch</h3>
            <ul className="footer-links footer-contact">
              <li><FiMail /><a href={`mailto:${company.email}`}>{company.email}</a></li>
              <li>
                <FiPhone />
                <span>
                  {company.phones.map((phone, index) => (
                    <React.Fragment key={phone.href}>
                      {index > 0 && <br />}
                      <a href={phone.href}>{phone.display}</a>
                    </React.Fragment>
                  ))}
                </span>
              </li>
              <li>
                <FiMapPin />
                <a href={company.mapUrl} target="_blank" rel="noopener noreferrer">{company.address}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} {company.legalName}. All rights reserved.</p>
          <p>
            <Link to="/privacy">Privacy Policy</Link> · Made in New Delhi, India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
